import * as React from "react";
import { eBranches } from "sb-resp-lib";
import { Scoreboards } from "../../../../../constants";
import { ScoreboardProps, Scoreboard } from "../../Scoreboard";
import { renderTeamsScore } from "../RenderMethods";

export const renderScore = (score1: string, score2: string, sportId: string, props: ScoreboardProps) => Scoreboards[eBranches[sportId]]
    ? <Scoreboard {...props} />
    : renderTeamsScore(score1, score2)